import React, { useCallback } from "react";
import QRCode from "qrcode";
import S from "../../styled";

import { Qrcode } from "styled-icons/fa-solid";

const QRCodeButton = (props) => {
  const { name, url, width, height } = props;
  const { t } = props.store;

  const downloadQRCodeImage = useCallback(() => {
    QRCode.toDataURL(url, { width: 256, errorCorrectionLevel: "H", margin: 1 })
      .then((url) => {
        const downloadLink = document.createElement("a");
        downloadLink.download = name || "QRCode";
        downloadLink.href = `${url}`;
        downloadLink.click();
      })
      .catch((error) => {
        console.error("Some error in downloading QR Code", error);
      });
  }, [name, url]);

  return (
    <S.Button gap={5} title={t("components.QRCodeButton.title")} width={width} minWidth={width} height={height} padding={0} smallSize onClick={downloadQRCodeImage}>
      <Qrcode size={12} margin />
      {t("components.QRCodeButton.label")}
    </S.Button>
  );
};

export default QRCodeButton;
